import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ConflictRecordsTab from "../../component/Conflicts/FormSelect/tabs/ConflictRecordsTab";
import ConflictCommitteesTab from "../../component/Conflicts/FormSelect/tabs/ConflictCommitteesTab";
import TranshumanceRoutesTab from "../../component/Conflicts/FormSelect/tabs/TranshumanceRoutesTab";
import UnconfiguredSubmodulePlaceholder from "../../component/shared/UnconfiguredSubmodulePlaceholder";
import { useAuth } from "../../context/AuthContext";
import { useModuleTabs } from "../../config/moduleCatalog";

const LOCAL_TABS = [
  { key: "records", label: "Conflict Records", View: ConflictRecordsTab },
  { key: "committees", label: "Conflict Committees", View: ConflictCommitteesTab },
  { key: "routes", label: "Transhumance Routes", View: TranshumanceRoutesTab },
];

const R05_TAB_KEYS = new Set(["records"]);

export default function ConflictsDispute() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isR05 = user?.roleId === "R05";
  const tabs = useModuleTabs("conflicts-dispute", LOCAL_TABS);
  const visibleTabs = isR05 ? tabs.filter((tab) => R05_TAB_KEYS.has(tab.key)) : tabs;

  const { pathname } = useLocation();
  const segment = pathname.split("/").filter(Boolean).pop();
  const activeTab = visibleTabs.find((tab) => tab.key === segment) ? segment : visibleTabs[0]?.key ?? "records";

  const handleTabChange = (key) => navigate(`/conflicts-dispute/${key}`);
  const activeTabDef = visibleTabs.find((tab) => tab.key === activeTab);
  const ActiveView = activeTabDef?.View ?? ConflictRecordsTab;

  return (
    <div className="min-h-screen bg-white px-4 py-5 sm:p-6">
      <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <div>
          <h1 className="text-xl font-bold text-gray-900 leading-none">Conflicts &amp; Dispute Records</h1>
          <p className="text-xs text-gray-400 mt-1.5">Monitor and report conflict and dispute records across states</p>
        </div>
        <span className="text-sm font-semibold text-gray-400 mt-1">FMLD-native</span>
      </div>

      <nav className="mb-5 flex flex-wrap gap-x-7 gap-y-2 border-b border-gray-200">
        {visibleTabs.map(({ key, label }) => {
          const isActive = activeTab === key;
          return (
            <button
              key={key}
              onClick={() => handleTabChange(key)}
              className={`relative pb-3 text-sm ${
                isActive ? "font-semibold text-green-600" : "font-medium text-gray-700 hover:text-green-700"
              }`}
            >
              {label}
              {isActive && <span className="absolute inset-x-0 -bottom-px h-0.5 rounded bg-green-600" />}
            </button>
          );
        })}
      </nav>

      {activeTabDef?.isCatalogOnly ? <UnconfiguredSubmodulePlaceholder label={activeTabDef.label} /> : <ActiveView />}
    </div>
  );
}
